import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Button, Navbar, Nav } from 'react-bootstrap';
import styled from 'styled-components';
import { FaSitemap, FaStream, FaHistory } from 'react-icons/fa';
import { useI18n } from '../i18n';
import LanguageSwitcher from './common/LanguageSwitcher';
import VersionHistoryModal from './version/VersionHistoryModal';

const ChoiceContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: var(--background-secondary);
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ChoiceCard = styled(Card)`
  width: 300px;
  text-align: center;
  padding: 2rem;
  margin: 1rem;
  border: 1px solid var(--border);
  border-radius: 8px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-10px);
    box-shadow: var(--shadow-hover);
  }

  .card-icon {
    font-size: 3rem;
    color: var(--primary);
    margin-bottom: 1rem;
  }

  .card-title {
    font-size: 1.5rem;
    font-weight: 500;
    margin-bottom: 0.5rem;
  }

  .card-text {
    color: var(--text-secondary);
  }
`;

const ChoicePage = () => {
  const navigate = useNavigate();
  const { t } = useI18n();
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');

  // History modal state
  const [showHistoryModal, setShowHistoryModal] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userInfo');
    navigate('/login');
  };

  return (
    <ChoiceContainer fluid className="p-0">
      <Navbar bg="primary" variant="dark" expand="lg" className="px-3">
        <Navbar.Brand href="#home" style={{ fontWeight: 500 }}>🌐 {t('choice:app_name')}</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link disabled className="text-white">{t('choice:hello_user', { name: userInfo.username || 'User' })}</Nav.Link>
            <div className="d-flex align-items-center gap-2">
              <Button
                variant="outline-light"
                size="sm"
                onClick={() => setShowHistoryModal(true)}
                title={t('version:viewHistory', 'Version History')}
              >
                <FaHistory />
              </Button>
              <LanguageSwitcher />
              <Button variant="outline-light" size="sm" onClick={handleLogout}>{t('common:actions.logout')}</Button>
            </div>
          </Nav>
        </Navbar.Collapse>
      </Navbar>

      <Content>
        <Row className="justify-content-center align-items-center">
            <h2 className="text-center mb-4" style={{ color: 'var(--text-primary)', fontWeight: '500' }}>{t('choice:choose_title')}</h2>
            <Col md="auto">
              <ChoiceCard onClick={() => navigate('/workflow')}>
                <div className="card-icon"><FaSitemap /></div>
                <Card.Body>
                  <Card.Title>{t('choice:advanced_title')}</Card.Title>
                  <Card.Text>{t('choice:advanced_desc')}</Card.Text>
                </Card.Body>
              </ChoiceCard>
            </Col>
            <Col md="auto">
              <ChoiceCard onClick={() => navigate('/agent')}>
                <div className="card-icon"><FaStream /></div>
                <Card.Body>
                  <Card.Title>{t('choice:simple_title')}</Card.Title>
                  <Card.Text>{t('choice:simple_desc')}</Card.Text>
                </Card.Body>
              </ChoiceCard>
            </Col>
        </Row>
      </Content>

      {/* Version History Modal */}
      <VersionHistoryModal
        show={showHistoryModal}
        onHide={() => setShowHistoryModal(false)}
      />
    </ChoiceContainer>
  );
};

export default ChoicePage; 
